import { ITraveller } from "../../booking/ITraveller";

export interface IHotelTraveller extends ITraveller {
    xType: HotelTravellerType;
    birthDate: string;
    room: string;
    mealplan: string;
}

export enum HotelTravellerType {
    Adult = "adult",
    child = "child",
}